<template>
  <div style="height: 100%;">
    <div style="padding-top: 15px;font-weight: bold;margin-left: 25px;margin-bottom: 10px;">
      <span
        style="width: 5px;height: 15px;border-left: 2px solid #299FFB;display: inline-block;margin-bottom: -2px;margin-right: 5px;"></span>
      <span>临停收费记录</span>
    </div>
    <el-row class=" h-100 overflow" style="padding-left: 5px;">
      <el-col v-if="!payList || payList.length <= 0">
        <no-data style="margin-top: 15%"></no-data>
      </el-col>
      <el-col :key="index" :lg="21" :md="23" :sm="21" :xl="21" :xs="21"
              style="border-bottom: 1px solid rgba(41, 159, 251, .2);margin-top: 15px;"
              v-for="(item,index) in payList">
<!--        <el-col :lg="2" :md="2" :sm="2" :xl="2" :xs="2" style="width: 8%">-->
<!--          <div>-->
<!--            <img class="carIcon" src="../../../assets/images/basic_operations/menu/车辆.png" />-->
<!--          </div>-->
<!--        </el-col>-->
        <el-col :lg="11" :md="9" :sm="11" :xl="11" :xs="11" style=";width: 30%;padding-left: 3%">
          <span class="carNumFont">{{ item.plate }}</span>
        </el-col>
        <el-col :lg="4" :md="7" :sm="6" :xl="6" :xs="6" style="width: 22%">
          <span class="carIn">￥{{ item.payFee }}元</span>
        </el-col>
        <el-col :lg="4" :md="7" :sm="6" :xl="6" :xs="6" style="margin-left: 8px;;width: 33%">
          <span class="carOut">{{ item.duration }}</span>
        </el-col>
        <el-col :lg="4" :md="7" :sm="6" :xl="6" :xs="6" style="margin-left: 2px;width: 10%">
          <span class="carTime">{{ item.payTime }}</span>
        </el-col>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {getTemporaryPay} from "@/network/parking";
import NoData from "@/components/NoData";
export default {
  name: "ParkingTemporaryPay",
  components: {NoData},
  mounted() {
    this.getRecordList()
  },
  created() {
    // this.$store.dispatch('addIntervalObj', {'getRecordList:5000': this.getRecordList})
  },
  destroyed() {
    // this.$store.dispatch('removeIntervalObj', 'getRecordList')
  },
  data() {
    return {
      //定时器名称
      getRecordListInterval: null,
      // 车辆进出统计信息集合
      payList: []
    }
  },
  methods: {
    // 临停缴费记录
    getRecordList() {
      getTemporaryPay().then(res => {
        if (res.data != null) {
          for (let i = 0; i < res.data.length; i++) {
            res.data[i].duration = this.secondToDate(res.data[i].duration)
            res.data[i].payTime = this.timeFormat(res.data[i].payTime)
            res.data[i].payFee = this.monCharger(res.data[i].payFee)
          }
          this.payList = res.data;
        }
      })
    },
    secondToDate(result) {
      var h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
      var m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
      var s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));
      return result = h + "时" + m + "分" + s+ "秒";
    },
    timeFormat(payTime){
      let split = payTime.split(" ");
      let hour = split[1]
      let split1 = hour.split(":");
      return split1[0]+":"+split1[1]
    },
    monCharger(mon){
      return (mon / 100).toFixed(2)
    }
  },
}
</script>

<style scoped>
ul {
  padding: 0;
  margin: 3px;
  list-style: none;
}

ul li {
  border-bottom: 1px solid rgb(15, 54, 97);
}

/* 图片文字对齐 */
.carStatu {
  padding-left: 30px;
  padding-right: 3px;
  vertical-align: middle;
}

.carStatuIcon {
  padding-right: 33px;
}

.carOut {
  width: 13px;
  height: 18px;
  font-size: 13px;
  font-family: Alibaba PuHuiTi 2.0;
  font-weight: normal;
  line-height: 45px;
  color: #D9DBE0;
  opacity: 1;
  vertical-align: middle;
}

.carIn {
  width: 13px;
  height: 18px;
  font-size: 13px;
  font-family: Alibaba PuHuiTi 2.0;
  font-weight: normal;
  line-height: 45px;
  color: #299BFF;
  vertical-align: middle;
}

.carIcon {
  width: 17px;
  height: 14px;
  opacity: 1;
  margin-right: 3px;
}

.carNumFont {
  width: 60px;
  height: 18px;
  font-size: 13px;
  font-family: Alibaba PuHuiTi 2.0;
  font-weight: normal;
  line-height: 45px;
  color: #FFFFFF;
  opacity: 1;
  vertical-align: middle;
}

.carTime {
  width: 94px;
  height: 18px;
  font-size: 13px;
  font-family: Alibaba PuHuiTi 2.0;
  font-weight: normal;
  line-height: 45px;
  color: #D9DBE0;
  opacity: 1;
  vertical-align: middle;
}
</style>
